import { render, staticRenderFns } from "./FullscreenGallery.vue?vue&type=template&id=6e13cce2"
import script from "./FullscreenGallery.vue?vue&type=script&lang=ts"
export * from "./FullscreenGallery.vue?vue&type=script&lang=ts"
import style0 from "./FullscreenGallery.vue?vue&type=style&index=0&id=6e13cce2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports